// eslint-disable-next-line @typescript-eslint/no-var-requires
const serverConfig = require("../../../../config/server.js");
import axios from "axios";

export const isMock = process.env.REACT_APP_DATA_MODE === "mock";

const BASE: string = serverConfig.api_base_url;

export async function getJson<T>(path: string): Promise<T> {
  const url = path.startsWith("http") ? path : `${BASE}${path}`;
  const res = await axios.get<T>(url);
  return res.data;
}

export async function postJson<T>(path: string, body: unknown): Promise<T> {
  const url = path.startsWith("http") ? path : `${BASE}${path}`;
  const res = await axios.post<T>(url, body);
  return res.data;
}
